"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BannerInfo = _interopRequireDefault(require("../BannerInfo"));

var _NewBanner = _interopRequireDefault(require("../../NewBanner"));

var _utils = require("../../utils");

function LightHouseBanner(props) {
  var _a = props.lhBgUrl,
      lhBgUrl = _a === void 0 ? '' : _a,
      bannerData = props.bannerData,
      bannerInfo = props.bannerInfo,
      onCallback = props.onCallback;
  var formatLhBgUrl = (0, _utils.fomateFileData)(lhBgUrl).url;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "lighthouse-container-include",
    style: formatLhBgUrl ? {
      backgroundImage: "url(" + formatLhBgUrl + ")"
    } : {}
  }, /*#__PURE__*/_react["default"].createElement(_NewBanner["default"], {
    styleType: "lightHouse",
    lightTheme: bannerData.lightTheme,
    title: bannerData.title,
    content: bannerData.content,
    backgroundUrlLogo: bannerData.backgroundUrlLogo,
    backgroundUrl: bannerData.backgroundUrl,
    buttonList: bannerData.buttonList,
    onCallback: onCallback
  }), /*#__PURE__*/_react["default"].createElement(_BannerInfo["default"], {
    styleType: "lightHouse",
    style: bannerInfo.style,
    flexTitle: bannerInfo.flexTitle,
    labelName: bannerInfo.labelName,
    infoList: bannerInfo.infoList,
    privilegeList: bannerInfo.privilegeList
  }));
}

var _default = LightHouseBanner;
exports["default"] = _default;